import { render, staticRenderFns } from "./PricelistModal.vue?vue&type=template&id=75734dd0&"
import script from "./PricelistModal.vue?vue&type=script&lang=js&"
export * from "./PricelistModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports